import React, { useState } from 'react'
import { useDebouncedCallback } from 'use-debounce'
import { assocPath } from 'ramda'
import PropTypes from 'prop-types'

const EmailFilter = ({ filter, setFilter, textEntryDebounceMs = 2000 }) => {
  // Track updates in local state for a smooth typing
  // experience.
  const [email, setEmail] = useState(filter.email)

  // updateParentFilter calls the given `setFilter`
  // based on local state, i.e. email to search for.
  const updateParentFilter = () => {
    setFilter(assocPath(['email'], email, filter))
  }

  // But only call `setFilter` debounced, so that we don't
  // cause rerenders and API calls with every keystroke.
  const updateParentFilterDebounced = useDebouncedCallback(updateParentFilter, textEntryDebounceMs)

  // Called when the value changes
  const changed = (e) => {
    setEmail(e.target.value)
    updateParentFilterDebounced.callback()
  }

  const cleared = () => {
    setEmail('') // Immediate local state
    setFilter(assocPath(['email'], '', filter)) // Parent filter
  }

  // TODO: On enter, update immediately
  const keyPressed = (e) => {
    if (e.key === 'Enter') {
      updateParentFilter()
    }
  }

  return (
    <div className='filter email'>
      <input
        id='email-filter-input'
        type='email'
        value={email || ''}
        onKeyPress={keyPressed}
        onChange={changed}
        placeholder='cardholder@host.com'
        title='Find transactions by customer email'
      />
      {email && (
        <button className='clear' onClick={cleared} title='Clear filter'>
          <i className='fas fa-times'></i>
        </button>
      )}
    </div>
  )
}

EmailFilter.propTypes = {
  filter: PropTypes.object.isRequired,
  setFilter: PropTypes.func.isRequired,
  textEntryDebounceMs: PropTypes.number,
}

export default EmailFilter
